import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { spaceMixin, mediaMixin, Box, Tabs } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import VALoanCalculatorDonutChart from './VALoanCalculatorDonutChart.js';
import VALoanCalculatorFields from './VALoanCalculatorFields.js';
import { FieldConfig, DEFAULT_VALUES_SHAPE } from './VALoanCalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './VALoanCalculator.utils.js';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import { omitUndefined } from '../../utils/lodash.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import VALoanCalculatorFullReportButton from './VALoanCalculatorFullReportButton.js';
import VALoanCalculatorLineChart from './VALoanCalculatorLineChart.js';
import { handleFieldClickEvent } from './VALoanCalculator.Clickstream.js';

var _templateObject;
var StyledCalculatorForm = /*#__PURE__*/styled(CalculatorForm).withConfig({
  componentId: "sc-tf37h2-0"
})(["padding-bottom:", ";display:flex;flex-direction:column-reverse;", ";"], spaceMixin('md'), mediaMixin('lg', css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            flex-direction: row;\n            justify-content: space-between;\n        "])))));
var VALoanCalculator = function VALoanCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  var finalDefaultValues = Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.homePrice.name] = 300000, _Object$assign[FieldConfig.loanProgram.name] = LOAN_PROGRAMS.fixed30Year, _Object$assign[FieldConfig.interestRate.name] = 4.176, _Object$assign[FieldConfig.downPayment.name] = 60000, _Object$assign[FieldConfig.downPaymentPercent.name] = 20, _Object$assign[FieldConfig.homeInsurance.name] = Math.round(300000 * 0.00035 * 12), _Object$assign[FieldConfig.hoa.name] = 0, _Object$assign[FieldConfig.taxRatePercent.name] = 1.2, _Object$assign[FieldConfig.taxRate.name] = 3600, _Object$assign[FieldConfig.includeTaxesInsurance.name] = true, _Object$assign), omitUndefined(defaultValues));
  return /*#__PURE__*/React.createElement(StyledCalculatorForm, {
    fieldStorageKey: "paymentfields",
    defaultValues: finalDefaultValues,
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(VALoanCalculatorFields, null), /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'sticky',
      top: '0',
      alignSelf: 'flex-start',
      '@media $md': {
        'flex-basis': '65%'
      }
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultSelected: "breakdown-tab"
  }, /*#__PURE__*/React.createElement(Tabs.List, {
    "aria-label": "Default tabs example"
  }, /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "breakdown-tab",
    "aria-controls": "breakdown-panel",
    type: "button",
    onClick: function onClick() {
      return handleFieldClickEvent('Breakdown', 'tab');
    }
  }, "Breakdown"), /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "schedule-tab",
    "aria-controls": "schedule-panel",
    type: "button",
    onClick: function onClick() {
      return handleFieldClickEvent('Schedule', 'tab');
    }
  }, "Schedule")), /*#__PURE__*/React.createElement(Tabs.Panels, null, /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "breakdown-panel",
    "aria-labelledby": "breakdown-tab"
  }, /*#__PURE__*/React.createElement(VALoanCalculatorDonutChart, null)), /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "schedule-panel",
    "aria-labelledby": "schedule-tab"
  }, /*#__PURE__*/React.createElement(VALoanCalculatorLineChart, null)))), /*#__PURE__*/React.createElement(VALoanCalculatorFullReportButton, null)));
};
VALoanCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var VALoanCalculator$1 = VALoanCalculator;

export { VALoanCalculator$1 as default };
